/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pb_Cta_DescInputs */

const en_pb_cta_desc = /** @type {(inputs: Pb_Cta_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Describe it in a few sentences. Bystep writes the plan and builds it step by step.`)
};

const id_pb_cta_desc = /** @type {(inputs: Pb_Cta_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ceritakan dalam beberapa kalimat. Bystep menulis rencananya dan membangunkan langkah demi langkah.`)
};

/**
* | output |
* | --- |
* | "Describe it in a few sentences. Bystep writes the plan and builds it step by step." |
*
* @param {Pb_Cta_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const pb_cta_desc = /** @type {((inputs?: Pb_Cta_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pb_Cta_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_pb_cta_desc(inputs)
	return en_pb_cta_desc(inputs)
});